import { createStore } from "zustand-x";
import { createJSONStorage } from "zustand/middleware";
import hashStorage from "../../utils/storage";
import { IAmbassadors } from "../../models/interfaces/IAmbassadors.interface";
import { modals } from "@mantine/modals";
import React from "react";
import { EModals } from "../../models/enums/modals.enums";
import { SingleCardView } from "../../themes/default/pages/ManageAmbassador/SingleCardView";

const initialState: IAmbassadors = {
  search: "",
  page: 1,
  pageSize: 15,
  totalRecords: 0,
  totalPages: 0,
  activeTab: "All",
  mode: "grid",
  activeStep: "basic-info",
  identifier: "",
  tabId: 0,
  form_type: "create"
};

const ambassadors = createStore<IAmbassadors>(initialState, {
  name: "Sp2vew",
  immer: {
    enabled: true,
  },
  persist: {
    enabled: true,
    storage: createJSONStorage(() => hashStorage),
  },
}).extendActions((set, get) => ({
  resetPage: () => {
    set.page(1);
  },
  setNextPage: () => {
    set.page(get.page() + 1);
  },
  setPrevPage: () => {
    set.page(get.page() - 1);
  },
  setPage: (pageNumber: number) => {
    set.page(pageNumber);
  },
  setPageSize: (perPage: 25 | 50 | 100) => {
    set.pageSize(perPage);
  },
  setTotalRecords: (totalRecords: number) => {
    set.totalRecords(totalRecords);
  },
  setTotalPage: (totalPages: number) => {
    set.totalPages(totalPages);
  },
  setActiveTab: (tab: string) => {
    set.activeTab(tab);
  },
  setMode: (mode: "grid" | "list") => {
    set.mode(mode);
  },
  setSearch: (search: string) => {
    set.search(search);
  },
  setFormType: (formType: "create" | "edit") => {
    set.form_type(formType);
  },
  setActiveStep: (
    step:
      | "basic-info"
      | "incentive-details"
      | "ambassador-type"
      | "origin-details"
      | "academics"
  ) => {
    set.activeStep(step);
  },
  setTabId: (tabId: number) => {
    set.tabId(tabId);
  },
  setIdentifier: (identifier: string) => {
    set.identifier(identifier);
  },
  openSingleCardView: (ambassador: any) => {
    modals.open({
      title: "",
      size: "lg",
      styles: {
        header: { backgroundColor: "rgb(221, 232, 242)" },
      },
      modalId: EModals.SINGLE_CARD_VIEW,
      children: React.createElement(SingleCardView, { ambassador }),
    });
  },
}));

export default ambassadors;
